const money = {
    decimal: ",",
    thousands: ".",
    prefix: "R$ ",
    suffix: "",
    precision: 2,
    masked: false
}
export default money